import { KabaddiIcon } from './KabaddiIcon';

/**
 * author: Google
 * id 24CB8442-6875-4A22-A265-0C625118C7E7
 * name kabaddi
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/kabaddi.svg
 * tags
 * - Sport 
 * - People / Family 
 */
export const HumanKabaddiIcon = KabaddiIcon;
export default HumanKabaddiIcon